import {
  ServiceFill18Icon,
  WarningFill18Icon,
} from "@vygruppen/spor-icon-react";
import { Box } from "shared/components/Spor";
import { trainRequiresMeasure } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/MeasureDescription";
import { AltTransIncidentTrain } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC } from "react";
import styled, { useTheme } from "styled-components";

type CollapsedIconProps = { actionableTrain: AltTransIncidentTrain };

const OverrideHardcodedYellowIcon = styled.div`
  * > *:first-child {
    fill: ${({ theme }) => theme.colorIconMain} !important;
  }
`;

export const CollapsedIcon: FC<CollapsedIconProps> = ({ actionableTrain }) => {
  const theme = useTheme();

  if (actionableTrain.measures.length > 0) {
    return (
      <OverrideHardcodedYellowIcon>
        <ServiceFill18Icon fill={theme.colorIconMain} />
      </OverrideHardcodedYellowIcon>
    );
  }

  if (trainRequiresMeasure(actionableTrain.events)) {
    return <WarningFill18Icon color={theme.colorWarning} />;
  }

  return <Box width="3" height="3" />;
};
